import React, {  useContext } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { GlobalContext } from "../../handlers/GlobalContext";


class Verify extends React.Component {
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.translate = this.translate.bind(this);
        this.resetSelection = props.reset;
        this.setSelection = props.set;
        this.verificationToken = props.token || '';
        this.preloadedToken = !!props.token;
        this.disabled = !!props.token;
    }

    //handleSubmit( values, { setSubmitting } ){
    handleSubmit( values, actions ){
        let dispatch = this.context[1];
        dispatch({ type: 'VERIFY_USER', payload: { username: values.username, token: values.token } })
            .then(() => {
                let authErrorMessage = !!this.context[0].error ? this.context[0].error.data : undefined;
                if(!!authErrorMessage) {
                    actions.setFieldError('message', this.translate(authErrorMessage));
                    actions.setSubmitting(false);
                } else {
                    if(!!this.context[0].message) {
                        alert(this.translate(this.context[0].message));
                    }
                    actions.setSubmitting(false);
                    this.resetSelection(true);
                }
            });
    }

    translate = (term, alt) => {
        return this.context[0].locale.translation[term] || alt || term;
    }

    render(){
        return(
            <div className="login-wrap text-center col">
                <h3>{this.translate("verify-title-verify","Verify")}</h3>

                <Formik
                    initialValues={{ username: '', token: this.verificationToken, message: '' }}
                    validate={values => {
                        const errors = {};
                        if (!values.username) {
                            errors.username = this.translate('login-error-usernameRequired','Username required!');
                        }
                        if (!values.token) {
                            errors.token = this.translate('verify-error-emptyToken','Verification token cannot be empty!');
                        }
                        return errors;
                    }}
                    onSubmit= { this.handleSubmit }
                >
                    {({ isSubmitting }) => (
                        <Form className="login-form">
                            <ErrorMessage name="message" component="div" className="error-field" />
                            {/*<Field type="email" name="email" />*/}
                            {/*<ErrorMessage name="email" component="div" />*/}
                            <Field type="text" name="username" className="formField" placeholder={this.translate("login-placeholder-username", "Username")} />
                            <ErrorMessage name="username" component="div" className="error-field" />
                            <Field type="text" name="token" placeholder={this.translate("verify-placeholder-token", "Verification token")} disabled={this.disabled} />
                            <ErrorMessage name="token" component="div" className="error-field" />
                            <button type="submit" disabled={isSubmitting}>
                                {this.translate("login-button-submit", "Submit")}
                            </button>
                            {
                                this.preloadedToken ?
                                    <button type="button" className={"secondary"} disabled={isSubmitting} onClick={() => {this.resetSelection(true)} }>
                                        {this.translate("login-button-back", "Back")}
                                    </button> :
                                    <button type="button" className={"secondary"} disabled={isSubmitting} onClick={() => {this.setSelection(1)} }>
                                        {this.translate("login-button-backToLogin", "Back to Login")}
                                    </button>
                            }


                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
}

Verify.contextType = GlobalContext;
export default Verify;